import { useAppSelector } from 'app/store';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';

/**
 * Whether the current user can switch companies: support users, or anyone who
 * belongs to more than one paidol. Single source of truth for the mobile
 * switcher's line-visibility (MobileHeader) and the Home content offset that
 * makes room for it (MobilePageContent), so the two can't drift. Mirrors the
 * web switcher's gate. Wraps the already-widely-mocked `selectUserCompanies`,
 * so consumers stay test-friendly.
 */
export const useCanSwitchCompany = (): boolean => {
  const { user, paidolUsers } = useAppSelector(selectUserCompanies);
  return Boolean(user?.is_support) || (paidolUsers?.length ?? 0) > 1;
};
